var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "DPRScripts",
        "content-class": "menu-bg-blue-transparent-modal",
        title: "Daily Productivity Report Automation Setting",
        "hide-footer": "",
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "b-row",
            { staticClass: "col-sm-12 p-4 text-center" },
            [
              _c("b-col", { staticClass: "col-sm-6" }, [
                _c(
                  "label",
                  { staticClass: "form-check-label font-weight-bold" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "typeFilter",
                        value: "all",
                        title: "All Systems",
                        checked: "",
                      },
                      domProps: { checked: _vm._q(_vm.type, "all") },
                      on: {
                        change: function ($event) {
                          _vm.type = "all"
                        },
                      },
                    }),
                    _vm._v("All Systems\n        "),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "col-sm-6" }, [
                _c(
                  "label",
                  { staticClass: "form-check-label font-weight-bold" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "typeFilter",
                        value: "one",
                        title: "New System",
                      },
                      domProps: { checked: _vm._q(_vm.type, "one") },
                      on: {
                        change: function ($event) {
                          _vm.type = "one"
                        },
                      },
                    }),
                    _vm._v("New System\n        "),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.type != "all"
            ? _c(
                "b-card",
                {
                  staticClass: "hide-hor-scroll p-1 menu-bg-blue-transparent",
                  attrs: {
                    id: "generateNewSystemEntriesWindow",
                    "header-html":
                      "<b>Generate Yearly DPR Entries for New System</b>",
                    "no-body": "",
                  },
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "px-3 py-2" },
                    [
                      _c("label", [_vm._v("Start Date *")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { name: "startDate", type: "date" },
                        model: {
                          value: _vm.startDate,
                          callback: function ($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticClass: "px-3 py-2" },
                    [
                      _c("label", [_vm._v("System Id *")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { name: "systemId" },
                        model: {
                          value: _vm.systemId,
                          callback: function ($$v) {
                            _vm.systemId = $$v
                          },
                          expression: "systemId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.submitErrors.length > 0
                    ? _c(
                        "b-row",
                        { staticClass: "p-2" },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _c(
                              "span",
                              [
                                _c("b", [
                                  _vm._v(
                                    "Please correct the following error(s):"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-list-group",
                                  _vm._l(_vm.submitErrors, function (error) {
                                    return _c(
                                      "div",
                                      {
                                        key: error,
                                        staticClass: "alert alert-danger",
                                      },
                                      [
                                        _c("b-list-group-item", [
                                          _vm._v(_vm._s(error)),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "p-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-md m-2",
                              attrs: { variant: "primary", type: "submit" },
                              on: {
                                click: function ($event) {
                                  return _vm.runNewSystem()
                                },
                              },
                            },
                            [_vm._v("\n            Execute\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "all"
            ? _c(
                "b-card",
                {
                  staticClass: "hide-hor-scroll p-1 menu-bg-blue-transparent",
                  attrs: {
                    id: "generateEntriesWindow",
                    "header-html": "<b>Generate Yearly DPR Entries</b>",
                    "no-body": "",
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "p-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-md m-2",
                              attrs: { variant: "primary", type: "submit" },
                              on: {
                                click: function ($event) {
                                  return _vm.runAllSystems()
                                },
                              },
                            },
                            [_vm._v("\n            Execute\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }